import React from 'react';
import { observer } from 'mobx-react';
import useStyles from './styles';
import { Typography } from '../../components/Wrappers/Wrappers.jsx';

import useWhiteLabel from '../../store/models/styles/useWhiteLabel';
function Footer () {
  const {
    whiteLabelSettings,
  } = useWhiteLabel();

  const classes = useStyles({ headerBackgroundColor: whiteLabelSettings.footerColor, whiteLabelSettings });

  return (
    <footer className={classes.body}>
      <Typography variant={'body2'} color="light">
        { whiteLabelSettings.copyrightText }
      </Typography>
    </footer>
  );
}

export default observer(Footer);
